import { Col, Descriptions, Row, Typography } from "antd";
import dayjs from "dayjs";
import React from "react";
import { useSelector } from "react-redux";
import { dateFormat, formatPhone } from "../shared/formatting";
import LabelWithEditAction from "../shared/form/LabelWithEditAction";
import { BulkUpdateActionType } from "./bulkUpdate/BulkUpdateModalConfig";

const formatProducerDisplay = (code, name) => {
  if (!name) return "";

  return code && code.trim()
    ? `${code} - ${name}`
    : name;
};

const RenewalSummary = ({ selected, onEditAction }) => {
  const maskSensitiveData = useSelector(
    (state) => state.actor?.details?.data?.MaskSensitiveData
  );

  const handleDocumentOpen = (documentKey) => {
    window.open(
      `${process.env.REACT_APP_BASENAME}documents/updatedocumentform/${documentKey}`,
      `${documentKey}`
    );
  };

  return (
    <Row>
      <Col span={24}>
        {selected && (
          <>
            <Descriptions
              size="small"
              column={3}
              items={[
                {
                  key: "policyNumber",
                  label: "Policy Number",
                  children: (
                    <Typography.Link
                      onClick={() => handleDocumentOpen(selected.DocumentKey)}
                    >
                      {selected.PolicyNumber}
                    </Typography.Link>
                  ),
                },
                {
                  key: "agency",
                  label: "Agency",
                  children: selected.AgencyNumberAndName,
                },
                {
                  key: "assignedTo",
                  label: (
                    <LabelWithEditAction
                      text="Assigned To"
                      onEdit={() => onEditAction(BulkUpdateActionType.ASSIGNEE)}
                    />
                  ),
                  labelStyle: { overflow: "visible" },
                  children: selected.AssignedTo || "(Unassigned)",
                },
                {
                  key: "plateNumber",
                  label: "Plate Number",
                  children: (
                    <Typography.Link
                      onClick={() => handleDocumentOpen(selected.DocumentKey)}
                    >
                      {selected.PlateNumber}
                    </Typography.Link>
                  ),
                },
                {
                  key: "policyType",
                  label: "Policy Type",
                  children: selected.PolicyType,
                },
                {
                  key: "reminderStatus",
                  label: "Processing Status",
                  children: selected.ProcessingStatusDesc,
                },
                {
                  key: "customer",
                  label: "Customer",
                  children: (
                    <div
                      className={
                        maskSensitiveData === true ? "blurry-text" : ""
                      }
                    >
                      {selected.InsuredName}
                    </div>
                  ),
                },
                {
                  key: "policyStatus",
                  label: "Policy Status",
                  children: selected.PolicyStatusDesc,
                },
                {
                  key: "processingStage",
                  label: "Processing Stage",
                  children: selected.LatestProcessingStageDesc,
                },

                {
                  key: "phone",
                  label: "Phone",
                  children: (
                    <div
                      className={
                        maskSensitiveData === true ? "blurry-text" : ""
                      }
                    >
                      {selected.CustomerPhone &&
                        formatPhone(selected.CustomerPhone)}
                    </div>
                  ),
                },
                {
                  key: "expiry",
                  label: "Expiry",
                  children: selected.PolicyExpiryDate
                    ? dayjs(selected.PolicyExpiryDate).format(dateFormat[0])
                    : "N/A",
                },
                {
                  key: "updatedDate",
                  label: "Updated Date",
                  children: selected.DateModified
                    ? dayjs(selected.DateModified).format(dateFormat[0])
                    : "N/A",
                },
                {
                  key: "email",
                  label: "Email",
                  children: (
                    <div
                      className={
                        maskSensitiveData === true ? "blurry-text" : ""
                      }
                    >
                      {selected.Email}
                    </div>
                  ),
                },
                {
                  key: "policyStatusChangeDate",
                  label: "Policy Status Change Date",
                  children: selected.PolicyStatusChangeDate
                    ? dayjs(selected.PolicyStatusChangeDate).format(
                        dateFormat[0]
                      )
                    : "N/A",
                },
                {
                  key: "producerCode1",
                  label: (
                    <LabelWithEditAction
                      text="Producer Code 1"
                      onEdit={() => onEditAction(BulkUpdateActionType.PRODUCER_1)}
                    />
                  ),
                  labelStyle: { overflow: "visible" },
                  children: formatProducerDisplay(selected.ProducerCode1, selected.ProducerName1),
                },
                {
                  key: "vehicle",
                  label: "Vehicle",
                  children: selected.Vehicle,
                },
                {
                  key: "policyStatusChangeAgency",
                  label: "Policy Status Change Agency",
                  children: selected.PolicyStatusChangeAgency,
                },
                {
                  key: "producerCode2",
                  label: (
                    <LabelWithEditAction
                      text="Producer Code 2"
                      onEdit={() => onEditAction(BulkUpdateActionType.PRODUCER_2)}
                    />
                  ),
                  labelStyle: { overflow: "visible" },
                  children: formatProducerDisplay(selected.ProducerCode2, selected.ProducerName2),
                },
              ]}
            />
          </>
        )}
      </Col>
    </Row>
  );
};

export default RenewalSummary;
